<template>
  <v-container>
    <v-content class="mic_container">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-form ref="deleteUserForm" lazy-validation class="mic_form">

            <v-toolbar dark color="#5ba322">
              <v-toolbar-title>Profil löschen</v-toolbar-title>
            </v-toolbar>
            <v-spacer></v-spacer>
            <div class="mic_form-content">
              <v-text-field v-model="userToDelete" autofocus clearable hint="E-Mail-Adresse des Accounts, dessen Daten gelöscht werden sollen" placeholder="melanie.musterfrau@example.com" ></v-text-field>
              <template>
                <v-layout row justify-center>
                  <v-dialog v-model="dialog" persistent max-width="290">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        :disabled="!userToDelete"
                        color="primary"
                        v-on="on"
                      >Profil löschen</v-btn>
                    </template>
                    <v-card>
                      <v-card-title class="headline">Daten wirklich löschen?</v-card-title>
                      <v-card-text>Alle Daten der Person mit der E-Mail-Adresse {{ userToDelete }} werden gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.</v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            @click="dialog = false"
                          >
                            Zurück
                          </v-btn>
                          <v-btn
                            color="red"
                            text
                            @click="handleSubmit"
                          >
                            Wirklich löschen
                          </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-layout>
              </template>
            </div>
          </v-form>
        </v-layout>
      </v-container>
    </v-content>
  </v-container>
</template>

<script>
import { userService } from '../_services'
export default {
  data () {
    return {
      userToDelete: '',
      dialog: false
    }
  },
  methods: {
    handleSubmit () {
      this.dialog = false
      const { dispatch } = this.$store

      userService.deleteUser(this.userToDelete).then(
        response => {
          dispatch('alert/success', 'Profil wurde erfolgreich gelöscht.', {
            root: true
          })
          this.$router.push('/tracking/overview')
        },
        error => {
          console.log(error)
          dispatch('alert/error', 'Fehler beim Löschen des Profils.', {
            root: true
          })
        }
      )
    }
  }
}
</script>

<style scoped="true">
.v-text-field {
  padding-top: 5!important;
  margin-top: 0!important;
}
</style>



// WEBPACK FOOTER //
// src/admin/DeleteUserPage.vue